// Single source of truth for the activity-log Category dropdowns and for turning a stored
// category code back into its display label. Both the super-admin Activity Log Report and
// the alumni-profile Activity Log read from here so the two screens cannot drift apart.
// Codes must stay in sync with the validation sets in broadcast/services/referralService.js.
export type ActivityCategory = { code: string; label: string };

export const ACTIVITY_CATEGORIES: ActivityCategory[] = [
    { code: 'ADMISSIONS_MARKETING', label: 'Admissions & Marketing' },
    { code: 'MENTORING_GUIDANCE', label: 'Career Guidance & Mentorship' },
    { code: 'FUNDRAISE', label: 'Fundraise' },
    { code: 'GENERAL_ENGAGEMENT', label: 'General Engagement' },
    { code: 'GRIEVANCE', label: 'Grievance' },
    { code: 'NETWORKING', label: 'Networking' },
    { code: 'NOSTALGIA', label: 'Nostalgia' },
    { code: 'PROFILE_UPDATE', label: 'Profile Update' },
    { code: 'RANKING_ACCREDITATION', label: 'Ranking & Accreditation' },
    { code: 'RECRUITMENT', label: 'Recruitment' },
    { code: 'RECOGNITION', label: 'Recognition' },
    { code: 'RECREATION', label: 'Recreation' },
    { code: 'SUPPORT_SERVICES', label: 'Support Services' },
    { code: 'SURVEY_RESPONSE', label: 'Survey Response' },
    { code: 'THOUGHT_LEADERSHIP', label: 'Thought Leadership' },
    { code: 'WATCHLIST', label: 'Watchlist' },
    { code: 'OTHERS', label: 'Others' },
];

const LABEL_BY_CODE = new Map(ACTIVITY_CATEGORIES.map(({ code, label }) => [code, label]));

// Unknown codes fall back to the de-underscored code, so rows written before a category
// existed still read sensibly instead of rendering blank.
export const getActivityCategoryLabel = (code?: string | null): string =>
    !code ? '' : LABEL_BY_CODE.get(code) ?? code.split('_').join(' ');
